// 6px radius reads as a small but clickable handle across common DPIs.
export const ROTATION_HANDLE_RADIUS = 6;
// 12px offset keeps the handle separated from the box edge for clarity.
export const ROTATION_HANDLE_OFFSET = 12;

export function normalizeRotation(angle: number): number {
  // Normalize angle to be within [0, 360)
  if (!Number.isFinite(angle)) return 0;
  // Normalize into the [0, 360) range while handling negative angles.
  return ((angle % 360) + 360) % 360;
}

export function rotatePoint(
  point: { x: number; y: number },
  center: { x: number; y: number },
  angleDeg: number,
) {
  const radians = (angleDeg * Math.PI) / 180; // Convert angle to radians
  const cos = Math.cos(radians); // Calculate cosine of the angle
  const sin = Math.sin(radians); // Calculate sine of the angle
  const dx = point.x - center.x; // Translate point to local coordinates
  const dy = point.y - center.y; // Translate point to local coordinates
  return {
    x: center.x + dx * cos - dy * sin, // Rotate point and translate back to global coordinates
    y: center.y + dx * sin + dy * cos, // Rotate point and translate back to global coordinates
  };
}

export function pointToAngle(
  center: { x: number; y: number },
  point: { x: number; y: number },
): number {
  const radians = Math.atan2(point.y - center.y, point.x - center.x);
  return normalizeRotation((radians * 180) / Math.PI);
}

export function getRotationHandleCenter(
  center: { x: number; y: number },
  height: number,
  rotation: number,
  offset = ROTATION_HANDLE_OFFSET,
) {
  return rotatePoint(
    { x: center.x, y: center.y - height / 2 - offset },
    center,
    rotation,
  );
}
